export { default as Content } from './Content';
export { default as Footer } from './Footer';
export { default as Headline } from './Headline';
